import axios from "axios";
import { API_BASE_URL } from "../config/constants";

class PeakTimeModel {
    constructor() {
        this._isPeakTime = false;
    }

    async fetchPeakTime() {
        try {
            const response = await axios.get(`${API_BASE_URL}peak-time`);

            if (response.status === 200 && typeof response.data.data === "boolean") {
                this._isPeakTime = response.data.data;
                return this._isPeakTime;
            } else {
                console.warn("Unexpected response format from peak time API.");
                return null;
            }
        } catch (error) {
            console.error("Error fetching peak time data:", error);
            return null;
        }
    }

    isPeakTime() {
        return this._isPeakTime;
    }
}

export default new PeakTimeModel();